import React from "react";
import { ButtonBase } from "../../../common/components/form";

/**
 * Modal window with actions.
 *
 * @param {*} props React component props:
 * - show boolean
 * - header (optional) string
 * - text (optional) string
 * - children (optional) any (JSX)
 *
 * - actions (optional) array:
 * ```JS
 * [{
 *      onClick: () => {},
 *      text: <span>Click</span> || "Click",
 *      props: { invert: true }, // additional props for ButtonBase
 * }]
 * ```
 */
export default function Modal(props) {
    const CNModal = ["modal"];
    props.show && CNModal.push("show");

    return (
        <div className={CNModal.join(" ")} style={{ ...props.style, zIndex: props.zIndex }}>
            <div className="modal-content">
                {props.header && <h2 className="modal-header">{props.header}</h2>}
                {props.text && <p className="modal-text">{props.text}</p>}

                {props.children && <div className="modal-children">{props.children}</div>}

                <div className="modal-actions">
                    {props?.actions?.map(({ onClick, text, props }, index) => (
                        <ButtonBase key={index} onClick={onClick} {...props}>
                            {text}
                        </ButtonBase>
                    ))}
                </div>
            </div>
        </div>
    );
}
